<template>
  <div class="cmp-permission" :class="{ 'cmp-selected-resource': actionLabels }">
    <div class="cmp-head">
      <div class="cmp-icon"><i class="fa-light" :class="icon"></i></div>
      <div class="cmp-title" :title="subtext">{{ label }}</div>
      <div class="cmp-reset">
        <a @click="resetAll" v-if="hasSavedConfiguration">{{ i18nJS.command.reset }}</a>
      </div>
      <div>
        <switchComponent :value="allChecked" @input="() => changeAction()" :label="isBusinessUnit ? 'Tutti' : null" :multiline="true" />
      </div>
    </div>
    <div class="cmp-switches-cont">
      <switchComponent
        v-for="(permission, action) in actions"
        :key="action"
        :value="permission.permit"
        @input="() => changeAction(action)"
        :label="isBusinessUnit ? permission.label : null"
        :is-circled="permission.isOverride"
        :multiline="true"
      />
    </div>
  </div>
</template>
<script>
import switchComponent from '../switchComponent';
const omit = (prop, { [prop]: _, ...rest }) => rest;

export default {
  name: 'editPermission',
  props: ['isBusinessUnit', 'icon', 'label', 'subtext', 'actionLabels', 'permissionKind', 'businessUnitId', 'permissions'],
  components: {
    switchComponent,
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    hasSavedConfiguration() {
      return !!(
        this.permissions.explain.length &&
        this.permissions.explain[0].level == this.permissionKind[0] &&
        this.permissions.explain[0].business_unit_id == this.businessUnitId
      );
    },
    permissionPayload() {
      const attributes = {
        permit: [],
        forbid: [],
        ...(this.hasSavedConfiguration ? omit('level', this.permissions.explain[0]) : {}),
        business_unit_id: this.businessUnitId,
        resource: this.permissions.resource,
      };
      switch (this.permissionKind[0]) {
        case 'role':
          return {
            ...attributes,
            role_code: this.permissionKind[1],
          };
        case 'ubu':
          return {
            ...attributes,
            role_code: this.permissions.role,
            account_business_unit_id: this.permissionKind[1],
          };
        default:
          return attributes;
      }
    },
    actions() {
      return Object.keys(this.actionLabels).reduce((acc, action) => {
        acc[action] = {
          label: this.actionLabels[action],
          permit: this.permissions.permit.indexOf(action) !== -1,
          isOverride: !!(
            this.hasSavedConfiguration &&
            (this.permissions.explain[0].permit.indexOf(action) != -1 || this.permissions.explain[0].forbid.indexOf(action) != -1)
          ),
        };
        return acc;
      }, {});
    },
    allChecked() {
      return Object.keys(this.actions)
        .map((e) => this.actions[e].permit)
        .every((e) => !!e);
    },
  },
  methods: {
    changeAction(action) {
      const permission = this.permissionPayload;
      let changeActions = action ? [action] : Object.keys(this.actions);
      const attributes = { ...permission };

      if (action) {
        const newValue = !this.actions[action].permit;
        attributes.permit = newValue ? [...permission.permit, action] : permission.permit.filter((p) => p != action);
        attributes.forbid = newValue ? permission.forbid.filter((p) => p != action) : [...permission.forbid, action];
      } else {
        attributes.permit = this.allChecked ? [] : Object.keys(this.actions);
        attributes.forbid = this.allChecked ? Object.keys(this.actions) : [];
      }
      this.$emit('onEditPermission', attributes);
    },
    resetAll() {
      this.$emit('onRemovePermission', this.permissionPayload);
    },
  },
};
</script>
<style scoped>
.cmp-permission {
  text-align: center;
  min-width: 120px;
}
.cmp-head {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
  background-color: #fff;
  z-index: 30;
  padding-top: 20px;
}
.cmp-icon {
  font-size: 23px;
  margin-bottom: 10px;
  color: #666;
  padding-left: 20px;
}
.cmp-title {
  overflow-y: scroll;
  height: 3em;
  line-height: 1em;
  padding-left: 20px;
}
.cmp-reset {
  font-size: 12px;
  height: 2em;
  cursor: pointer;
  padding-left: 20px;
}

.cmp-selected-resource {
  text-align: inherit;
}

.cmp-selected-resource .cmp-title {
  font-weight: 600;
}

.cmp-head .cmp-switch-cont {
  background: none !important;
}
.cmp-selected-resource .cmp-switch-cont:nth-child(odd) {
  background: #f3f5f7;
}

.cmp-switches-cont .cmp-switch-cont {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  padding: 10px 14px;
  border: none !important;
}
.cmp-selected-resource .cmp-switch-cont {
  justify-content: inherit;
  margin-bottom: 10px;
  padding: 10px 14px;
  border: none !important;
}
</style>
